import { render, staticRenderFns } from "./DlgModeratorsForgot.vue?vue&type=template&id=53231c3a&scoped=true&"
import script from "./DlgModeratorsForgot.vue?vue&type=script&lang=js&"
export * from "./DlgModeratorsForgot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53231c3a",
  null
  
)

export default component.exports